import { gql, TypedDocumentNode } from "@apollo/client";

import {
  PendingUserTeamInvitesQuery,
  PendingUserTeamInvitesQueryVariables,
} from "./GetUserTeamInvites.generated";

export const GET_PENDING_USER_TEAM_INVITES: TypedDocumentNode<
  PendingUserTeamInvitesQuery,
  PendingUserTeamInvitesQueryVariables
> = gql`
  query pendingUserTeamInvites {
    pendingUserTeamInvites {
      uuid
      timeSent
      team {
        uuid
        name
      }
      sender {
        uuid
        firstName
        lastName
      }
    }
  }
`;
